// Sample broker data for template generation
export const sampleBrokerData = [
  {
    BROKER: 'Sample Broker 1',
    PRICE_FILE: 'SAMPLE_FILE_001',
    SOURCE: 'EMAIL',
    EMAIL: 'broker1@example.com',
    SUBJECT: 'Daily Pricing File - Sample 1',
    SECURITY_LIST: 'Y',
    ADDITIONS: 'N',
    CUSIPS: '123456789,987654321,456789123'
  },
  {
    BROKER: 'Sample Broker 2',
    PRICE_FILE: 'SAMPLE_FILE_002',
    SOURCE: 'FTP',
    EMAIL: 'broker2@example.com',
    SUBJECT: 'Weekly Pricing Update - Sample 2',
    SECURITY_LIST: 'N',
    ADDITIONS: 'Y',
    CUSIPS: '111222333,444555666,777888999'
  }
];
